import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, DropletOff, Clock, Eye, Cpu, UserCheck } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Benefits() {
  const {
    t
  } = useLanguage();
  const benefits = [{
    icon: <ShieldCheck data-id="element-33" />,
    title: t('benefits.b1.title'),
    desc: t('benefits.b1.desc')
  }, {
    icon: <DropletOff data-id="element-34" />,
    title: t('benefits.b2.title'),
    desc: t('benefits.b2.desc')
  }, {
    icon: <Clock data-id="element-35" />,
    title: t('benefits.b3.title'),
    desc: t('benefits.b3.desc')
  }, {
    icon: <Eye data-id="element-36" />,
    title: t('benefits.b4.title'),
    desc: t('benefits.b4.desc')
  }, {
    icon: <Cpu data-id="element-37" />,
    title: t('benefits.b5.title'),
    desc: t('benefits.b5.desc')
  }, {
    icon: <UserCheck data-id="element-38" />,
    title: t('benefits.b6.title'),
    desc: t('benefits.b6.desc')
  }];
  // Duplicate for seamless marquee
  const marqueeItemsRow1 = [...benefits, ...benefits];
  const marqueeItemsRow2 = [...benefits.reverse(), ...benefits.reverse()];
  return <section id="beneficios" className="py-32 bg-white overflow-hidden" data-id="element-39">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-41">
          <h2 className="font-heading font-bold text-5xl md:text-7xl text-bodyon-teal-dark tracking-tight" data-id="element-42">
            ¿Por qué{' '}
            <span className="italic bg-gradient-to-r from-[#2B7A8F] via-[#30BBA8] to-[#5CD4C2] bg-clip-text text-transparent" data-id="element-43">
              Body • On
            </span>
            ?
          </h2>
        </motion.div>
      </div>

      <div className="flex flex-col gap-8 relative" data-id="element-44">
        {/* Gradient fades for edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-45"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-46"></div>

        {/* Row 1: Scrolls Left */}
        <div className="flex w-[200%] animate-marquee-left pause-on-hover" data-id="element-47">
          {marqueeItemsRow1.map((benefit, index) => <div key={index} className="w-[400px] flex-shrink-0 px-4" data-id="element-48">
              <div className="bg-bodyon-surface border border-gray-200 p-8 rounded-[32px] h-full flex flex-col hover:border-bodyon-teal transition-colors duration-300" data-id="element-49">
                <div className="w-16 h-16 rounded-2xl bg-white shadow-sm flex items-center justify-center text-bodyon-teal mb-6" data-id="element-50">
                  {cloneElement(benefit.icon as React.ReactElement, {
                className: 'w-8 h-8'
              })}
                </div>
                <h3 className="font-heading font-bold text-2xl text-bodyon-teal-dark mb-3" data-id="element-51">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 font-light text-lg" data-id="element-52">
                  {benefit.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Row 2: Scrolls Right */}
        <div className="flex w-[200%] animate-marquee-right pause-on-hover -ml-[100%]" data-id="element-53">
          {marqueeItemsRow2.map((benefit, index) => <div key={index} className="w-[400px] flex-shrink-0 px-4" data-id="element-54">
              <div className="bg-white border border-gray-200 shadow-sm p-8 rounded-[32px] h-full flex flex-col hover:border-bodyon-teal transition-colors duration-300" data-id="element-55">
                <div className="w-16 h-16 rounded-2xl bg-bodyon-surface flex items-center justify-center text-bodyon-teal-dark mb-6" data-id="element-56">
                  {cloneElement(benefit.icon as React.ReactElement, {
                className: 'w-8 h-8'
              })}
                </div>
                <h3 className="font-heading font-bold text-2xl text-bodyon-teal-dark mb-3" data-id="element-57">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 font-light text-lg" data-id="element-58">
                  {benefit.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}